import * as React from "react";
const SvgFiRrDepartment = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-department_svg__a)">
      <path
        fill="#062147"
        d="M10 2a2 2 0 1 1 3.999-.001A2 2 0 0 1 10 2m4 15a2 2 0 1 0-3.999-.001A2 2 0 0 0 14 17m6.5-9a2 2 0 1 0-.001 3.999A2 2 0 0 0 20.5 8m-15 2a2 2 0 1 0-3.999-.001A2 2 0 0 0 5.5 10m-2 5c.71 0 1.329.504 1.47 1.199a1 1 0 1 0 1.96-.399 3.51 3.51 0 0 0-3.43-2.801 3.51 3.51 0 0 0-3.43 2.802 1 1 0 0 0 1.96.399 1.5 1.5 0 0 1 1.47-1.199zM12 5a3.51 3.51 0 0 0-3.43 2.801 1 1 0 0 0 1.96.399A1.5 1.5 0 0 1 12 7.001c.711 0 1.329.504 1.47 1.199a1 1 0 1 0 1.96-.399A3.51 3.51 0 0 0 12 5m0 15a3.51 3.51 0 0 0-3.43 2.801 1 1 0 0 0 1.96.399A1.5 1.5 0 0 1 12 22.001c.711 0 1.329.504 1.47 1.199a1 1 0 1 0 1.96-.399A3.51 3.51 0 0 0 12 20m11.93-4.699A3.51 3.51 0 0 0 20.5 12.5a3.51 3.51 0 0 0-3.43 2.801 1 1 0 0 0 1.96.399 1.5 1.5 0 0 1 1.47-1.199c.711 0 1.329.504 1.47 1.199a1 1 0 1 0 1.96-.399M7 2H6C3.794 2 2 3.794 2 6a1 1 0 1 0 2 0c0-1.103.897-2 2-2h1a1 1 0 1 0 0-2m11 2c1.103 0 2 .897 2 2a1 1 0 1 0 2 0c0-2.206-1.794-4-4-4h-1a1 1 0 1 0 0 2zm3 13a1 1 0 0 0-1 1c0 1.103-.897 2-2 2a1 1 0 1 0 0 2c2.206 0 4-1.794 4-4a1 1 0 0 0-1-1M6 20c-1.103 0-2-.897-2-2a1 1 0 1 0-2 0c0 2.206 1.794 4 4 4a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-department_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDepartment;
